<template>
	<div class="news">
		<div class="innerhdon">
			<mbHd />
		</div>
		<div class="innerCon">
			<div class="wrapper">
				<currentLocation title="查询历史"></currentLocation>
				<div class="member clearfix">
					<memberFl></memberFl>
					<div class="memberFr">
						<div class="mbTit">
					   <h3><img class="mbTiticon" :src="mbTiticon" />查询历史</h3>
					  </div>
					  <div class="queryTab">
					  	<ul>
					  		<li class="on">全部({{historyLength}})</li>
					  		<!-- <li>默认分组（0） </li>
					  		<li>竞争对手（0）</li>
					  		<li>供应商（0）</li>
					  		<li>客户（0）</li> -->
					  	</ul>
					  </div>
					  	<div class="reasultLst">
							<div class="lst">
								<ul>
									<li  v-for=" item in params" :key="item.index">
										<div class="item clearfix">
											<!-- <div class="pic">
												<img src="../assets/img/img12.jpg" />
											</div> -->
											<div class="txt">
												<h5>{{item.companyName}}</h5>
												<div class="info">
													<span><strong>法定代表人:</strong>  {{item.legalPersonName}}</span>
													<span><strong>地址:</strong>  {{item.regLocation}}</span>
													<span><strong>行业:</strong>  {{item.industry}}</span>
													<span><strong>历史时间:</strong>  {{item.createTime}}</span>
												</div>
											</div>
										</div>
										<a  @click="historyInfo(item)" class="contactIt">查看详情</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
		<rightFix />
	</div>
</template>
<script>

import mbHd from '@/components/mbHd.vue'
import foot from '@/components/foot.vue'
import rightFix from '@/components/rightFix.vue'
import currentLocation from '@/components/currentLocation.vue'
import memberFl from '@/components/memberFl.vue'
import paging from '@/components/paging.vue'
export default {
  name: 'News',
  components: {
    foot,
    rightFix,
    mbHd,
    currentLocation,
    memberFl,
    paging
  },
  data () {
    return {
	  mbTiticon: require('@/assets/img/icon.png'),
	  phone: '',
	  params: {},
	  info: '',
	  info2: '',
	  rename: '',
	  companyName: '',
	  historyLength: null,
    }
  },
  methods: {
    getList () {
		   const member = localStorage.getItem('member')
		   const newMember = JSON.parse(member)
		   const memberId = newMember.memberId
		   const info = { memberId: memberId }
		   this.$api.getHistoryByMemberId(info).then(response => {
		   this.params = response.data
		   this.historyLength = response.data.length
		  })
    },
    historyInfo (item) {
		  this.rename = item.companyName.replace(/<[^>]+>/g, '')
		  this.info = { id: item.companyId, name: this.rename }
		  this.info2 = { businessId: item.companyId, name: this.rename }
		  this.$router.push({
        name: 'enterpriseInfoDeatl',
        params: {
          param: JSON.stringify(this.info),
          param2: JSON.stringify(this.info2)
		    }
      })
	  }
  },
  mounted () { // 调用path是否相同，相同就设置为true
	 this.$store.commit('getindex', this.$route.path)
  },
  created () {
    this.getList()
  }
}
</script>
<style scoped lang="scss">

</style>
